<template>

    <Form @submit="onSubmit" :validation-schema="schema">

        <div class="container">
            <div class="row justify-content-center">


                <div class="booking-container-n px-md-4 px-3">


                    <div class="room-guest-names bg-white has-shadow p-md-5 pb-4 pt-5 px-4">
                        <h3 class="mb-4">Spa guest names:</h3>

                        <div v-for="(guest, gIndex) in guests"
                             v-bind:key="gIndex"
                             class="form-group row mb-4">
                            <div class="col-24">

                                <div class="iamthisguest">
                                    <span>
                                        <span class="text-uppercase">Guest {{gIndex+1}}</span>
                                    </span>
                                </div>



                                <div class="row mb-3" v-if="isAuthenticated">
                                    <div class="col-24">
                                        <label class="iamthisguest">
                                            I am this guest
                                            <input style="margin-left: 20px"
                                                   type="checkbox"
                                                   v-on:click="setAuthenticatedGuest(gIndex)"
                                                   v-model="stayingGuestIndex"
                                                   v-bind:true-value="gIndex"
                                                   false-value="-1" />
                                        </label>

                                        <Field type="hidden" v-model="guest.isLoggedInUser" v-bind:name="`guests.[${gIndex}].isLoggedInUser`" />

                                    </div>
                                </div>

    

                                <div class="row">
                                    <div class="col-md-12 col-xl-6 mb-4 mb-xl-0">

                                        <Field v-if="stayingGuestIndex != gIndex"
                                               v-bind:name="`guests[${gIndex}].title`" as="select" class="form-select" v-model="guest.title">
                                            <option disabled selected value="">Title</option>
                                            <option v-for="title in titles" v-bind:key="title.OperaCode" v-bind:value="title.OperaCode">{{title.DisplayName}}</option>
                                        </Field>

                                        <Field readonly v-else v-bind:name="`guests[${gIndex}].title`" type="text" v-model="guest.title" class="form-control" />


                                        <ErrorMessage v-bind:name="`guests[${gIndex}].title`" class="error-message" />
                                    </div>

                                    <div class="col-xl-9 mb-4 mb-xl-0">

                                        <Field v-bind:readonly="stayingGuestIndex == gIndex"
                                               v-bind:name="`guests[${gIndex}].firstName`"
                                               type="text" class="form-control" placeholder="First Name" v-model="guest.firstName" />
                                        <ErrorMessage v-bind:name="`guests[${gIndex}].firstName`" class="error-message" />
                                    </div>

                                    <div class="col-xl-9">

                                        <Field v-bind:readonly="stayingGuestIndex == gIndex"
                                               v-bind:name="`guests[${gIndex}].lastName`"
                                               placeholder="Last Name"
                                               v-model="guest.lastName"
                                               type="text" class="form-control" />
                                        <ErrorMessage v-bind:name="`guests[${gIndex}].lastName`" class="error-message" />
                                    </div>
                                </div>

                            </div>
                        </div>


                    </div>











                </div>
            </div>
        </div>





        <actions-bar>
            <template v-slot:actions>
                <div class="row">
                    <div class="col-12">

                        <button v-on:click="onBack"
                                type="button"
                                class="btn btn--transparent btn--back">
                            Back
                        </button>
                    </div>
                    <div class="col-12 d-flex justify-content-end">
                        <button class="btn btn--slate-blue btn--continue"
                                type="submit">
                            Next Step
                        </button>
                    </div>
                </div>
            </template>
        </actions-bar>

    </Form>

</template>

<script>


    import { Field, Form, ErrorMessage } from "vee-validate";
    import * as yup from "yup";

    import ActionsBar from '@/shared/components/ActionsBar.vue';

    import { store } from '../store/index';
    import { accountStore } from '@/account/store/index';



    export default {
        name: 'SpaTreatmentGuests',
        components: {
            ActionsBar,


            Field,
            Form,
            ErrorMessage
        },
        mounted() {
            if (this.search.guests != null) {
                this.guests = this.search.guests;
            }
            else {
                let guests = [];
                for (let guestIndex = 0; guestIndex < this.search.guestCount; guestIndex++) {
                    guests.push({ title: null, firstName: '', lastName: '', isLoggedInUser:false})
                }

                this.guests = guests;
            }
        },
        computed: {
            session() {
                return store.getters.session
            },
            booking() {
                return store.getters.booking;
            },
            titles() {

                return store.getters.configuration.Titles;
            },
            search() {
                return store.getters.search;
            },
            isAuthenticated() {
                return accountStore.getters.isAuthenticated;
            },
            userProfile() {
                return accountStore.getters.userProfile;
            }
        },
        data() {
            let guests = [];

            const schema =
                yup.object().shape({
                    guests: yup
                        .array()
                        .of(yup.object().shape({
                            title: yup.string().nullable().required().label("Title"),
                            firstName: yup.string().nullable().required().label("First name"),
                            lastName: yup.string().nullable().required().label("Last name"),
                            isLoggedInUser: yup.boolean(),
                        }))
                }).strict();

            return {
                stayingGuestIndex: null,
                guests,
                schema
            }
        },
        methods: {

            onSubmit: function (values) {
                let payload = {
                    guests: values.guests
                };
                
                store.dispatch("setGuests", payload).then(() => {
                    this.$router.push({ name: 'spa_treatment_treatments', params: { id: this.session.Id } });
                });
            },
            onBack: function () {
                this.$router.push({
                    name: 'spa_treatment_search', params: { id: this.session.Id }
                });
            },

            setAuthenticatedGuest(index) {
                var originalState = this.guests[index].isLoggedInUser || false;

                for (let gi = 0; gi < this.guests.length; gi++) {

                    let guest = this.guests[gi];
                    guest.isLoggedInUser = false;
                    guest.firstName = '';
                    guest.lastName = '';
                    guest.title = '';

                }

                if (!originalState) {
                    let guest = this.guests[index];

                    guest.isLoggedInUser = true;
                    guest.firstName = this.userProfile.FirstName;
                    guest.lastName = this.userProfile.LastName;
                    guest.title = this.userProfile.Title;
                }

            },

        }
    }
</script>


<style src="@/shared/css/guests.css"></style>

<style>
    .iamthisguest {
        font-weight: bold;
        margin-bottom: 10px;
        font-size: 14px !important;
        cursor: pointer;
        margin-right: 20px;
    }

        .iamthisguest input[type=checkbox] {
            width: 20px;
            height: 20px;
            position: relative;
            top: 4px;
        }
</style>